export default [
  {
    title: 'breadcrumb.resultReport',
    route: 'result-report',
    icon: '',
    resource: 'result-report',
    action: 'read'
  }
];